import * as tslib_1 from "tslib";
import { IgrColumn } from "./igr-column";
import { ComboBoxColumn } from "./ComboBoxColumn";
/**
 * A combobox column.
*/
var IgrComboBoxColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrComboBoxColumn, _super);
    function IgrComboBoxColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrComboBoxColumn.prototype.createImplementation = function () {
        return new ComboBoxColumn();
    };
    Object.defineProperty(IgrComboBoxColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrComboBoxColumn.prototype, "actualDataSource", {
        /**
         * Gets the actual data source that is being used by the combo. If a collection was provided for the combobox data, an implicit LocalDataSource is created, and this is available via this property.
        */
        get: function () {
            return this.i.ji;
        },
        set: function (v) {
            this.i.ji = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrComboBoxColumn.prototype, "dataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.jj;
        },
        set: function (v) {
            this.i.jj = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrComboBoxColumn.prototype, "textField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.jn;
        },
        set: function (v) {
            this.i.jn = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrComboBoxColumn.prototype, "valueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.jg;
        },
        set: function (v) {
            this.i.jg = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrComboBoxColumn;
}(IgrColumn));
export { IgrComboBoxColumn };
//# sourceMappingURL=igr-combo-box-column.js.map
